import { BaseComponent } from "utils/base-component"

import "./index.scss"

type FilterState = {
  pistes?: number
  lifts?: number
  checkboxes: { [key: string]: boolean }
}

type Config = {
  onChange: () => void
}

export class Filter extends BaseComponent<Config> {
  static cssClass = "resort-finder-filter"

  private state!: FilterState
  private inputs!: HTMLInputElement[]

  getState() {
    return this.state
  }

  init() {
    this.state = { checkboxes: {} }

    this.inputs = this.elements("pistes-lifts-input").map(
      (input) => input.element as HTMLInputElement,
    )
    this.inputs.forEach((input) => {
      input.addEventListener("input", () => {
        this.readInputValues()
        this.config.onChange()
      })
    })

    this.inputs = this.elements("pistes-lifts-input").map(
      (input) => input.element as HTMLInputElement,
    )
    this.inputs.forEach((input) => {
      input.addEventListener("input", () => {
        this.readInputValues()
        this.config.onChange()
      })
    })

    this.addCheckbox("snowsure")
    this.addCheckbox("piste-variety")
    this.addCheckbox("off-piste")
    this.addCheckbox("scenery")
    this.addCheckbox("apres-ski")

    this.readInputValues()

    // Trigger initial load if any checkboxes are checked by default
    const hasCheckedFilters = Object.values(this.state.checkboxes).some((checked) => checked)
    if (hasCheckedFilters) {
      this.config.onChange()
    }
  }

  private readInputValues() {
    this.state.pistes = Number(this.inputs[0].value)
    this.state.lifts = Number(this.inputs[1].value)
  }

  private addCheckbox(field: string) {
    const checkbox = this.element(field)!.element as HTMLInputElement

    // Initialize state with current checkbox state (in case it's checked by default)
    this.state.checkboxes[field] = checkbox.checked

    checkbox.addEventListener("click", () => {
      this.state.checkboxes[field] = checkbox.checked
      this.config.onChange()
    })
  }
}
